import { Col, Row } from "v2/components/base/Flex/ui";
import { forwardRef } from "react";
import CloseButtons from "v2/components/Buttons/CloseButton";

interface ModelHeaderProps {
  close?: () => void;
}

export const withModelHeaderWrapper = (HeaderWrapperComponent: React.ComponentType<any>) => {
  return forwardRef<any, React.PropsWithChildren<ModelHeaderProps>>(({ ...props }, ref) => {
    return <HeaderWrapperComponent ref={ref} close={props.close} {...props} />;
  });
};
